
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/ipl/purple-cap",
      function () {
        return require("private-next-pages/sports/ipl/purple-cap/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/ipl/purple-cap"])
      });
    }
  